import {
  Bokforingsar_db_SYSBokfar_All,
  Bokforingsar_db_SYSBokfPeriod_All,
} from '../Query/_QueryTypes/Bokforingsar';
import { getYearFromDate } from '../../../Utils/dateUtils';
import {
  TEDSYSBokfarLASTEnum,
  TEDSYSBokfPeriodLASTEnum,
} from '../../../globalQueryTypes';

interface IBokforingsperiod {
  __typename: 'TEDSYSBokfPeriod';
  PERIOD: number;
  LAST: TEDSYSBokfPeriodLASTEnum;
}
interface IBokforingsar {
  __typename: 'TEDSYSBokfar';
  id: string;
  BOKF_AR: any;
  LAST: TEDSYSBokfarLASTEnum;
  _Associations: {
    Bokfperiod: IBokforingsperiod[];
  };
}

const isPeriodLocked = (
  bokforingsarList: IBokforingsar[],
  year: number,
  month: number
): boolean => {
  const bokforingsAr = bokforingsarList.find(bokforingsar => {
    const bokforingsarYear = getYearFromDate(bokforingsar.BOKF_AR);

    return bokforingsarYear === year;
  });

  if (bokforingsAr) {
    if (bokforingsAr.LAST === 'LAST') {
      return true;
    } else {
      if (bokforingsAr._Associations) {
        if (bokforingsAr._Associations.Bokfperiod) {
          const bokforingsperiod = bokforingsAr._Associations.Bokfperiod.find(
            bokforingsperiod => bokforingsperiod.PERIOD === month
          );

          if (bokforingsperiod) {
            return bokforingsperiod.LAST === 'LAST';
          }
        }
      }
    }

    return false;
  } else {
    return true;
    // throw new Error(`Could not find bokföringsår at year ${year}`);
  }
};

export const isPeriodSpanLocked = (
  bokforingsarList: IBokforingsar[],
  year: number,
  fromMonth: number,
  toMonth?: number
): boolean => {
  if (fromMonth < 1 || fromMonth > 13) {
    return true;
  }
  if (toMonth !== undefined && (toMonth < 1 || toMonth > 13)) {
    return true;
  }

  if (toMonth === undefined) {
    toMonth = fromMonth;
  }

  const result: boolean[] = [];
  for (let i = fromMonth; i <= toMonth; i++) {
    result.push(isPeriodLocked(bokforingsarList, year, i));
  }

  return result.every(b => b);
};

export const insertPeriod = (
  bokforingsarList: Bokforingsar_db_SYSBokfar_All[],
  bokforingsarPeriodList: Bokforingsar_db_SYSBokfPeriod_All[]
): IBokforingsar[] => {
  return bokforingsarList.map(bokfar => ({
    ...bokfar,
    _Associations: {
      Bokfperiod: bokforingsarPeriodList.filter(
        bokfperiod => bokfar.BOKF_AR === bokfperiod.BOKF_AR
      ),
    },
  }));
};
